module.exports = __webpack_public_path__ + "static/q3_x-f9dcfd3511d1f48909379892c79e147f.png";